export const CONTENT_SINGLE_TEXT = 'single-text';
export const CONTENT_TEXT = 'text';
export const CONTENT_IMAGE = 'image';
export const CONTENT_TARGET = 'target';
export const CONTENT_CHILDS = 'childs';
export const CONTENT_MULTIPLE_IMAGE = 'multiple-image';
export const CONTENT_SLIDER_TEXT = 'slider-text';
export const CONTENT_LINKS = 'links';
export const CONTENT_SNIPPET = 'snippet';
export const CONTENT_CHECKBOX = 'checkbox';



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/Content/contentConstants.js